import { render, staticRenderFns } from "./People.vue?vue&type=template&id=137b072d&scoped=true&"
var script = {}
import style0 from "./People.vue?vue&type=style&index=0&id=137b072d&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137b072d",
  null
  
)

export default component.exports